export const COLORS = {
  //base
  WHITE: '#ffffff',
  BLACK: '#000000',
  //greens
  CELADON_GREEN: '#00887A',
  PERSIAN_GREEN: '#009688',
  PERSIAN_GREEN_LIGHT: '#00a797',
  KEPPEL_01: '#00B89F',
  KEPPEL_02: '#00BCA3',
  KEPPEL_03: '#00BFA5',
  KEPPEL_04: '#26C3AE',
  KEPPEL_05: '#01BEA4',
  MEDIUM_TURQUOISE: '#4ACDBB',
  //greys
  LIGHT_GREY_01: '#f5f5f5',
  DARK_GREY_01: '#39383d',
};
